module.exports = __webpack_public_path__ + "static/Flexible Terms Icon-hover-19e5ef66fb390f54511e934ffc919fe4.svg";